
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/diagnostics/resolved",
      function () {
        return require("private-next-pages/diagnostics/resolved.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/diagnostics/resolved"])
      });
    }
  